import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { GeolocationService } from '@ng-web-apis/geolocation';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { PaginationService } from 'src/app/PaginationService';
import { qmsService } from 'src/app/qms/qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { BsDatepickerConfig, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-add-document-from-popup',
  templateUrl: './add-document-from-popup.component.html',
  styleUrls: ['./add-document-from-popup.component.scss']
})
export class AddDocumentFromPopupComponent implements OnInit, OnDestroy {

  @Output() valueChange = new EventEmitter<boolean>;
  dateCustomClasses: any;
  selectedTabIndex = 0;
  docTypeForDocSearchText: string = '';
  documentTypeDropdown: any;
  selectedDocumentTypeForDoc: any = null;
  dropDownForDesignationCode: any = [];
  dropDownForDepartmentCode: any = [];
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  taskStagesList: any = [];
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    private readonly elem: ElementRef, public message: messageService, public qmsservice: qmsService, private readonly datePipe: DatePipe, private readonly activatedRoute: ActivatedRoute,
    public paginationService: PaginationService, public SVC: messageService, private readonly geolocation$: GeolocationService) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  viewableExtensionsList: any = [];
  allowedFileExtns: any = "*.*";
  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit(): void {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.appService.getDmsSettingVw().subscribe((data: any) => {
      if (data.viewableFileExtns != null) {
        this.viewableExtensionsList = data.viewableFileExtns.split(",");
      }
      if (data.allowedFileExtns != null) {
        this.allowedFileExtns = null;
        let extns = data.allowedFileExtns.split(",");
        this.allowedFileExtns = extns
          .map((ext: string) => `.${ext.toLowerCase()}`)
          .join(',');
      }


    })
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.selectBoxeForDesignationCode();
    this.selectBoxeForDepartmentCode();
  }
  snackBarRef: any;

  showSnackBar(message: string, type: string) {
    this.snackBarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: 5000,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: "Ok"
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackBarRef.onAction().subscribe(() => {
      this.snackBarRef.dismiss();
    });
  }

  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';

  public readonly $commonDateConfig: Readonly<Partial<BsDatepickerConfig>> = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  };

  public $getDateConfig(field: any): Readonly<Partial<BsDatepickerConfig>> {
    let minDate: Date | null = null;
    let maxDate: Date | null = null;

    const lov = String(field.fieldLovValues ?? '').trim();

    if (lov == "Current Date") {
      minDate = new Date();
      maxDate = new Date();
    } else if (lov == "Future Date") {
      minDate = new Date();
    } else if (lov == "Past Date") {
      maxDate = new Date();
    } else if (lov.includes("+")) {
      minDate = new Date();
      const x = new Date();
      maxDate = new Date();
      maxDate.setDate(x.getDate() + Number.parseInt(lov.split("+")[1]));
    } else if (lov.includes("-")) {
      const x = new Date();
      minDate = new Date();
      minDate.setDate(x.getDate() - Number.parseInt(lov.split("-")[1]));
      maxDate = new Date();
    }

    return {
      ...this.$commonDateConfig,
      dateInputFormat: this.dateFormat,
      minDate: minDate!,
      maxDate: maxDate!
    };
  }

  public onDateChange(datepicker: BsDatepickerDirective): void {
    setTimeout(() => { datepicker.show(); }, 0);
  }

  public $getDateTimeConfig(field: any): Readonly<Partial<BsDatepickerConfig>> {
    let minDate: Date | null = null;
    let maxDate: Date | null = null;

    const lov = String(field.fieldLovValues ?? '').trim();

    if (lov == "Current Date") {
      minDate = new Date();
      maxDate = new Date();
    } else if (lov == "Future Date") {
      minDate = new Date();
    } else if (lov == "Past Date") {
      maxDate = new Date();
    } else if (lov.includes("+")) {
      minDate = new Date();
      const x = new Date();
      maxDate = new Date();
      maxDate.setDate(x.getDate() + Number.parseInt(lov.split("+")[1]));
    } else if (lov.includes("-")) {
      const x = new Date();
      minDate = new Date();
      minDate.setDate(x.getDate() - Number.parseInt(lov.split("-")[1]));
      maxDate = new Date();
    }

    return {
      ...this.$commonDateConfig,
      dateInputFormat: this.dateFormat + ' HH:mm:ss',
      minDate: minDate!,
      maxDate: maxDate!,
      withTimepicker: true,
    };
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  documentDataForDocBulkUpload: any = {
    revisionHistory: ''
  };
  isAddDocForBulkUpload = true;
  isShowAddPanel = false;
  isAddDocForDocType = true;
  isShowAddDocForDocType = false;
  documentAddOptionForFolder: any;
  dropDownFordocumentTypeList: any = [];
  savedFlexiDocIds: any[] = [];
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  model = {
    documentData: {},
  };
  selectedFolderForCreateDoc: any = {};
  documentDataForDocType: any = {
    expirationDate: Date
  }

  changeInFolderStructureChildForSearch(data: any) {
    this.model = data;
    this.selectedFolderForCreateDoc = this.model.documentData;
    this.isShowAddPanel = true;
    this.isAddDocForDocType = false;

  }
  isDocumentNoManuallyForDocType: any;
  isVersionManuallyForDocType: any;
  isProcessing = false;
  selectedFolderId = null;
  userPrivData: any;
  changeInFolderStructureChild(data: any) {
    this.model = data;
    this.selectedFolderForCreateDoc = this.model.documentData;

    this.selectedFolderId = this.selectedFolderForCreateDoc.folderId;
    this.isProcessing = true;


    this.appService.getDmsFolderDataById(this.selectedFolderForCreateDoc.folderId)
      .subscribe((data: any) => {
        this.isProcessing = false;
        if (data[0].allowToInputDocumentNoManually == "Y") {
          this.isDocumentNoManuallyForDocType = true;
        } else {
          this.isDocumentNoManuallyForDocType = false;
        }
        if (data[0].allowToInputVersionManually == "Y") {
          this.isVersionManuallyForDocType = true;
        } else {
          this.isVersionManuallyForDocType = false;
        }
        this.appService.getDocumentPrivUser(this.selectedFolderId).subscribe((response: any) => {
          if (data.length > 0) {
            if (response[0].author == "Y" || response[0].allusrAuthor == "Y" || response[0].rmAuthor == "Y") {
              this.isShowAddPanel = true;
              this.isAddDocForDocType = false;
              this.isShowAddDocForDocType = true;
              this.dropDownFordocumentTypeList = [];
              this.appService.getDocumentTypeBasedOnModule("DOCS")
                .subscribe((response1: any) => {
                  this.dropDownFordocumentTypeList = response1;
                  this.isProcessing = false;
                  this.documentTypeDropdown = [];
                  this.documentTypeDropdown = this.dropDownFordocumentTypeList.map((doc: any) => ({
                    valueExp: doc.documentTypeCode,
                    displayExp: doc.documentTypeName
                  }));
                  if (data[0].documentTypeCode) {
                    this.documentTypeDropdown = [];
                    let docTypes = data[0].documentTypeCode.split(",");
                    for (const code of docTypes ?? []) {
                      for (const doc of this.dropDownFordocumentTypeList ?? []) {
                        if (code === doc.documentTypeCode) {
                          this.documentTypeDropdown = [
                            ...(this.documentTypeDropdown ?? []),
                            {
                              valueExp: doc.documentTypeCode,
                              displayExp: doc.documentTypeName
                            }
                          ];
                        }
                      }
                    }
                  } else {
                    this.documentTypeDropdown = [];
                    for (const doc of this.dropDownFordocumentTypeList ?? []) {
                      this.documentTypeDropdown.push({
                        valueExp: doc.documentTypeCode,
                        displayExp: doc.documentTypeName
                      });
                    }
                  }
                })
            } else {
              this.warningMsg = "User do not have privilege to add document."
              this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
            }
          } else {
            this.warningMsg = "User do not have privilege to add document."
            this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
          }

        })


      })
    this.isProcessing = true;
    this.appService.getDocumentPrivUser(this.selectedFolderId).subscribe((data: any) => {
      this.isProcessing = false;
      this.userPrivData = data[0];
      if (this.userPrivData.blinded == "Y") {
        this.iSBlindTheDoc = true;
      }
    })

  }

  validateVersion(event: any) {
    if (event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-') {
      event.preventDefault();
    }
  }

  flexifields: any = null;
  flexiFieldsList: any = [];
  selectedFlexifieldValue: any = [];
  flexifieldObj: any = {};
  isShowFlexifieldBlock = false;
  callForFlexifields() {
    const selectedDocument = this.dropDownFordocumentTypeList.find(
      (doc: any) => doc.documentTypeCode === this.documentDataForDocBulkUpload?.documentTypeCode
    );

    if (selectedDocument) {
      this.flexifields = selectedDocument.listOfFlexifields;
    }
    if (this.flexifields) {
      let obj = {

        flexifieldIds: this.flexifields,
        module: "DOCS"
      }
      this.appService.getFlexifieldsListForDocument(obj).subscribe((data: any) => {
        this.flexiFieldsList = data;
        this.isShowFlexifieldBlock = true;
        const dropdownFieldTypes = new Set([
          "Drop Down",
          "Multiselect Drop Down",
          "Horizontal Checkbox Button",
          "Vertical Checkbox Button",
          "Horizontal Radio Button",
          "Vertical Radio Button"
        ]);

        for (const field of this.flexiFieldsList ?? []) {
          field.dropDownValues = [];
          field.dropdowns = [];
          field.checkedCheckBoxValue = [];
          field.selectedFlexifieldValue = [];

          field.originalDefaultValue = field.fieldDefaultValue;

          if (dropdownFieldTypes.has(field.fieldType) && field.fieldLovValues != null) {
            field.dropDownValues = field.fieldLovValues.split(",");

            for (const value of field.dropDownValues) {
              field.dropdowns.push({
                valueExp: value,
                displayExp: value
              });
            }
          }
        }
      })
    } else {
      this.isShowFlexifieldBlock = false;
    }

  }
  flexifieldSearchTxt: string = '';
  onFlexifieldSelect(item: any, data: any) {
    data.fieldDefaultValue = item.valueExp;
  }

  onFlexifieldRemoved(item: any) {

  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 100)
  }
  checkBoxChecked(data: any, event: any, val: any) {
    if (event.checked) {
      data.checkedCheckBoxValue.push(val);
    } else {
      let index = data.checkedCheckBoxValue.indexOf(val);
      data.checkedCheckBoxValue.splice(index, 1);
    }
  }

  makeVariable(data: any) {
    let splittedData = data.mappingColumn.toLowerCase().split("_");
    for (let j = 1; j < splittedData.length; j++) {
      splittedData[j] = splittedData[j].charAt(0).toUpperCase() + splittedData[j].slice(1);
    }
    let finalvariable = splittedData.join('');
    return finalvariable;
  }

  flexifield: any;
  flexifieldNameRequiredMsg: any;
  flexifieldValidation() {
    for (let i = 0; i < this.flexiFieldsList.length; i++) {
      const field = this.flexiFieldsList[i];
      const flexifieldEl = document.getElementById('flexifield' + i);
      const requiredMsgEl = document.getElementById('flexifield' + i + '-required-msg');

      let isInvalid = false;

      // Only check validation IF the field is mandatory
      if (field.isMandatory === 'Y') {
        const isCheckbox = field.fieldType === 'Horizontal Checkbox Button' || field.fieldType === 'Vertical Checkbox Button';
        const isMultiselect = field.fieldType === 'Multiselect Drop Down';

        if (isCheckbox) {
          if ((field.checkedCheckBoxValue?.length ?? 0) === 0) isInvalid = true;
        } else if (isMultiselect) {
          if (!field.selectedFlexifieldValue || field.selectedFlexifieldValue.length === 0) isInvalid = true;
        } else {
          if (field.fieldDefaultValue == null || String(field.fieldDefaultValue).trim() === '') {
            isInvalid = true;
          }
        }
      }

      // Apply UI changes specifically to this single field
      if (isInvalid) {
        if (flexifieldEl) flexifieldEl.style.border = '1px solid red';
        if (requiredMsgEl) requiredMsgEl.style.display = 'block';
      } else {
        if (flexifieldEl) flexifieldEl.style.border = 'none';  // Clear red border
        if (requiredMsgEl) requiredMsgEl.style.display = 'none'; // Hide error message
      }
    }
  }

  crGroupsSearchText: string = '';
  departmentSearchText: string = '';
  designationSearchText: string = '';
  isShowUserBelongsToField = false;
  isShowCrFields: boolean = false;
  isCrFeildIsMandatory: boolean = false;
  documentTypeData: any;
  isShowIsBlindedFlag = false;
  templateData: any;
  isViewableFile = false;
  document: File | null = null;
  previousFileName: any = "";
  isDownloadTemplate: boolean = false;
  isShowViewer = false;
  selectedTabIndexForDoc = 0;
  selectedDocumentTypeValue: any;
  isShowAssociatedDocumentField: any;
  isShowExpDate: any = false;
  followSameExpDate: any;
  ondocumentTypeForDocSelect(event: any, item: any) {

    if (event.isUserInput) {
      if (item) {
        this.selectedDocumentTypeValue = item;
        this.isShowAssociatedDocumentField = false;
        this.isShowUserBelongsToField = false;
        this.isShowCrFields = false;
        this.isShowExpDate = false;
        this.isCrFeildIsMandatory = false;
        this.documentDataForDocBulkUpload['documentTypeCode'] = this.selectedDocumentTypeValue;
        for (const element of this.dropDownFordocumentTypeList) {
          if (element.documentTypeCode == item) {
            this.documentTypeData = element;
            if (element.isAssociatedDocumentType == "Y") {
              this.isShowAssociatedDocumentField = true;
            }
            if (element.belongsToIndividual == "Y") {
              this.isShowUserBelongsToField = true;
            }
            if (element.isExpiryApplicable == "Y") {
              this.isShowExpDate = true;
            }
            if (element.associatedDocToFollowSameExpiry == "Y") {
              this.followSameExpDate = true;
            }
            if (element.isBlindable == "Y") {
              this.isShowIsBlindedFlag = true;
            }

            if (element.crProcess == "Mandatory" || element.crProcess == "Non Mandatory") {
              this.isShowCrFields = true;
              if (element.crProcess == "Mandatory") {
                this.isCrFeildIsMandatory = true;
              } else if (element.crProcess == "Non Mandatory") {
                this.isCrFeildIsMandatory = false;
              }
            }
          }
        }
        if (this.documentDataForDocBulkUpload['effectiveDate'] != null) {
          this.selectExpValue(new Date(this.documentDataForDocBulkUpload['effectiveDate']));
        }

        this.callForFlexifields();
      } else {
        [
          this.selectedDocumentTypeValue,
          this.isShowCrFields,
          this.isShowIsBlindedFlag,
          this.isShowAssociatedDocumentField,
          this.isShowUserBelongsToField,
          this.isCrFeildIsMandatory
        ] = ['', false, false, false, false, false]
      }
    }
  }

  iSBlindTheDoc: any;

  selectExpValue(date: Date) {
    if (this.documentTypeData.expiryInUnit != null) {
      this.documentDataForDocBulkUpload['expirationDate'] = new Date();
      this.documentDataForDocBulkUpload['expirationDate'].setDate(date.getDate());
      this.documentDataForDocBulkUpload['expirationDate'].setMonth(date.getMonth());
      this.documentDataForDocBulkUpload['expirationDate'].setFullYear(date.getFullYear());
      if (this.documentTypeData.expiryInUnit == "Days") {
        this.documentDataForDocBulkUpload['expirationDate'].setDate(date.getDate() + this.documentTypeData.expiryIn);
      } else if (this.documentTypeData.expiryInUnit == "Month") {
        this.documentDataForDocBulkUpload['expirationDate'].setMonth(date.getMonth() + this.documentTypeData.expiryIn);
      } else {
        this.documentDataForDocBulkUpload['expirationDate'].setFullYear(date.getFullYear() + this.documentTypeData.expiryIn);
      }
    }
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  buttonLabels: any[] = [];
  stageName: any;
  actionStatusOptions: any;
  instructions: any;
  buttonLabel: string = '';
  reason: string = '';
  isApplyToAllCheckIn: boolean = false;
  isApplyToAll: boolean = false;
  trainingList: any[] = [];
  selectedTrainingIds: any[] = [];
  selectedTrainingId: any = null;
  getOneQmsUsersTrainingsRepVwDetails: any[] = [];
  pagedItemsMain: any[] = [];
  pager: any = {};
  perPage = 10;
  collectionSize = 0;
  maxSize = 3;

  visiblPublishPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('publishPopup', { static: true }) publishPopup: TemplateRef<any>;
  publishPopupConfig = { width: '75%', height: 'auto', hasBackdrop: true, disableClose: true, position: { top: '30px' } };

  visiblPublishConfirmPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('publishConfirmPopup', { static: true }) publishConfirmPopup: TemplateRef<any>;
  publishConfirmPopupConfig = { width: '500px', height: 'auto', hasBackdrop: true, disableClose: true, position: { top: '30px' } };

  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;
  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  confirmWithReasonPopupConfig = {
    width: '500px', height: 'auto', panelClass: 'my-dialog', hasBackdrop: true, disableClose: true, position: { top: '10px' },
  };

  @ViewChild('bulkResultPopup', { static: true }) bulkResultPopup: TemplateRef<any>;
  visibleBulkResultPopup: MatDialogRef<TemplateRef<any>>;
  bulkOperationResults: any[] = [];

  @ViewChild('searchDocument', { static: true }) searchDocument: TemplateRef<any>;
  visibleSearchDocumentPopup: MatDialogRef<TemplateRef<any>>;

  searchDocumentConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  @ViewChild('searchCr', { static: true }) searchCr: TemplateRef<any>;
  visibleSearchCrPopup: MatDialogRef<TemplateRef<any>>;

  searchCrConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  @ViewChild('resultDisplayPopup', { static: true }) resultDisplayPopup: TemplateRef<any>;
  visibleDisplayResultPopup: MatDialogRef<TemplateRef<any>>;

  displayResultPopupConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };


  visibleCrInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;

  crInfoPopupConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  okInfo() {
    this.visibleCrInfoPopup.close();
  }

  selectedCrGroup: any = null;
  qmsGroupsList: any = [];
  checkoutcrId: any = null;
  checkoutcrNo: any = null;
  crValue: any = null;
  searchCrFunction(data: any) {
    this.selectedCrGroup = null;
    this.selectedCrGroupValue = null;
    this.searchedCrList = [];
    this.crValue = data;
    this.qmsGroupsList = [];

    this.appService.getQmsGroups().subscribe((data: any) => {
      for (const item of data ?? []) {
        if (item.modules?.includes('CR')) {
          this.qmsGroupsList.push(item);
        }
      }

      this.selectedCrGroup = null;
      this.selectBoxeForGroupValue();

    })
    this.isShowSearchedCrGrid = false;
    this.visibleSearchCrPopup = this.dialog.open(this.searchCr, this.searchCrConfig);
  }
  groupValueDropdown: any = [];
  selectedCrGroupValue: any = null;
  selectBoxeForGroupValue() {
    this.groupValueDropdown = [];
    for (const group of this.qmsGroupsList ?? []) {
      this.groupValueDropdown.push({
        valueExp: group.groupId,
        displayExp: group.groupName
      });
    }
  }

  onGroupValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedCrGroupValue = item.valueExp;
      }
    }
  }

  onGroupValueSelectOld(item: any) {
    this.selectedCrGroupValue = item.valueExp;
  }

  onGroupValueRemoved(item: any) {

  }

  gridResetFunction() {
    this.searchedCrList = [];
    this.selectedCrGroup = null;
    this.selectedCrGroupValue = null;
  }

  isShowSearchedCrGrid = false;
  searchedCrList: any = [];
  seachCrForDocumentsFunc() {
    if (this.selectedCrGroupValue == null || this.selectedCrGroupValue == "") {
      this.groupFieldValidation();
    } else {
      this.isShowSearchedCrGrid = true;
      this.isProcessing = true;
      this.appService.getCrForDocuments(this.selectedCrGroupValue)
        .subscribe((data: any) => {
          this.searchedCrList = data;
          this.isProcessing = false;
        })
    }
  }

  groupCss: any;
  groupCssReqdMsg: any;
  groupFieldValidation() {
    this.groupCss = document.getElementById('groupSearch') as HTMLInputElement;
    this.groupCssReqdMsg = document.getElementById('groupSearch-required-msg') as HTMLInputElement;

    if (this.selectedCrGroupValue == null || this.selectedCrGroupValue == "") {
      this.groupCss.style.border = '1px solid red';
      this.groupCssReqdMsg.style.display = 'block';
    } else {
      this.groupCss.style.border = 'none';
      this.groupCssReqdMsg.style.display = 'none';
    }
  }

  getSelectedCrNo: any = null
  getSelectedCrId: any = null
  warningMsg = "";
  searchCrChildCheckBoxChecked(e: any, cr: any, index: any) {
    if (e.target.checked) {
      cr.searchCrChildCheckBoxs = true;
      this.getSelectedCrNo = cr.crNo;
      this.getSelectedCrId = cr.crId;
      if (this.crValue == "Document") {
        this.isProcessing = true;
        this.appService.getCrCountForDoc(cr.crNo).subscribe((data: any) => {
          this.isProcessing = false;
          if (data > 0) {
            this.warningMsg = "The selected CR is already assigned to different document.";
            this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
          }
        })
      }
    } else {
      cr.searchCrChildCheckBoxs = false;
      this.getSelectedCrNo = null;
      this.getSelectedCrId = null;
    }
  }


  addCrFunction() {

    this.documentDataForDocBulkUpload.crNo = this.getSelectedCrNo;
    this.documentDataForDocBulkUpload.crId = this.getSelectedCrId;


    this.visibleSearchCrPopup.close();
  }

  cancelCrFunction() {
    this.visibleSearchCrPopup.close();
  }
  selectBoxeForDesignationCode(): void {
    for (const item of this.dropDownForDesignationCode ?? []) {
      this.designationCodeDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }

  selectBoxeForDepartmentCode(): void {
    for (const item of this.dropDownForDepartmentCode ?? []) {
      this.departmentCodeDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }
  @ViewChild('searchUser', { static: true }) searchUser: TemplateRef<any>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;

  searchUserConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };


  searchUserParentCheckBox: boolean = false;
  searchUserChildCheckBoxs: boolean = false;
  searchUserChildCheckBoxsMenu: boolean = false;

  searchUserDataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;
    for (const row of this.getOneQmsUsersVwDetailsTableData ?? []) {
      row.searchUserChildCheckBoxs = isChecked;
    }
  }
  getSelectedUserId: any;
  getSelectedUserName: string;
  searchUserChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {

    if (e.target.checked) {
      listOfUsersVwDetails.searchUserChildCheckBoxs = true;
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userName;
    } else {
      listOfUsersVwDetails.searchUserChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }

  }

  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];

  searchUserValue: any;
  popupDataTitle = {
    title: ""
  }

  searchUserFunction(value: any) {
    this.searchUserValue = value;
    this.searchUserChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.popupDataTitle.title = "Search User";
    this.visibleSearchUserPopup = this.dialog.open(this.searchUser, this.searchUserConfig);


  }

  addUserNameFunction() {
    this.documentDataForDocBulkUpload.belongsUserId = this.getSelectedUserId;
    this.documentDataForDocBulkUpload.belongsUserName = this.getSelectedUserName;
    this.visibleSearchUserPopup.close();
  }

  cancelSearchUserFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    this.visibleSearchUserPopup.close();
  }

  searchUserGridDataFunction(): void {
    this.isProcessing = true;
    this.designationCodeValue = this.searchByDesignationCode ?? null;
    this.departmentCodeValue = this.searchByDepartmentCode ?? null;

    if (!this.searchByUserName) {
      this.searchByUserName = '';
    }
    const processedUserName = this.searchByUserName.toUpperCase();

    this.searchOneQmsUserVwDetails = {
      userName: processedUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      status: "active"
    };

    const priv = this.userPrivData;
    if (priv.author === 'Y') {
      this.searchOneQmsUserVwDetails.userPriv = "AUTHOR";
    } else if (priv.allusrAuthor === 'Y' && priv.rmAuthor === 'Y') {
      this.searchOneQmsUserVwDetails.userPriv = "ALLUSERRMAUTHOR";
    } else if (priv.allusrAuthor === 'Y') {
      this.searchOneQmsUserVwDetails.userPriv = "ALLUSERAUTHOR";
    } else if (priv.rmAuthor === 'Y') {
      this.searchOneQmsUserVwDetails.userPriv = "RMAUTHOR";
    }

    this.appService.searchUsersForDmsDocuments(this.searchOneQmsUserVwDetails).subscribe((response: any) => {
      this.getOneQmsUsersVwDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  resetSearchUserGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }

  selectedDesignationValue: any;
  selectedDepartmentValue: any;
  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedDesignationValue = item?.valueExp ?? null;
    }
  }

  onDesignationCodeSelectOLd(item: any) {

    this.selectedDesignationValue = item.valueExp;
  }
  onDesignationCodeRemoved(item: any) { }

  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedDepartmentValue = item?.valueExp ?? null;
    }
  }

  onDepartmentCodeSelectOld(item: any) {

    this.selectedDepartmentValue = item.valueExp;
  }
  onDepartmentCodeRemoved(item: any) { }


  onTabChanged1(event: any) {

  }

  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  openFileDialog() {
    this.fileInput.nativeElement.click();
  }

  filesListToUpload: any = [];
  uploadFilePathextension: any;
  uploadFilePath: any;
  files: any = [];
  uploadedFiles: any = [];
  uploadProgress: number | null = null;

  onFileSelected(event: any) {
    this.files = event.target.files;
    let obj: any[] = [];
    if (event.target.files.length > 0) {
      let isFileAllowed = true;
      let fileExtns = "";
      for (const file of event.target.files) {
        const extension: string = (file.name.split('.').pop() ?? '').toLowerCase();

        if (!this.allowedFileExtns.includes(extension)) {
          isFileAllowed = false;
          fileExtns = fileExtns ? `${fileExtns},${extension}` : extension;
        }
      }
      if (isFileAllowed) {
        let formData = new FormData();
        for (const file of event.target.files) {
          const extension: string = (file.name.split('.').pop() ?? '').toLowerCase();

          if (!this.allowedFileExtns.includes(extension)) {
            fileExtns = fileExtns ? `${fileExtns},${extension}` : extension;
          }
        }

        for (const file of event.target.files) {
          const lastDotIndex: number = file.name.lastIndexOf('.');
          const name: string = lastDotIndex == -1 ? file.name : file.name.substring(0, lastDotIndex);
          const extension: string = (file.name.split('.').pop() ?? '').toLowerCase();

          obj.push({

            pageName: "DMS",
            fileName: name,
            extension: extension
          });

          this.uploadedFiles.push(`${name}.${extension}`);
          formData.append('file', file);
        }
        this.isProcessing = true;
        this.uploadProgress = 0;

        const json = JSON.stringify(obj);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('objects', blob);

        this.appService.multiFileUploadToServer(formData)
          .subscribe({
            next: (event: HttpEvent<any>) => {
              // Check if it's a progress event using the specific enum type
              if (event.type === HttpEventType.UploadProgress) {
                if (event.total) {
                  this.uploadProgress = Math.round((100 * event.loaded) / event.total);
                }
              } else if (event.type === HttpEventType.Response) {
                // Handle complete response
                this.isProcessing = false;
                this.uploadProgress = null; // Reset progress

                const data: any[] = event.body ?? [];
                for (const item of data) {
                  this.filesListToUpload.push(item);

                  if (item.resultType === "E") {
                    const statusType = item.resultType === 'S' ? 'Success' : 'Error';

                    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                      duration: 5000,
                      data: {
                        message: item.result,
                        type: statusType,
                        buttonLabel: "Ok"
                      },
                      horizontalPosition: 'center',
                      verticalPosition: 'top',
                      panelClass: statusType,
                    });

                    sb.onAction().subscribe({
                      next: () => sb.dismiss()
                    });
                  }
                }
              }
            },
            error: (error: any) => {
              this.isProcessing = false;
              this.uploadProgress = null;
              throw error;
            }
          });
      } else {
        let warningMsgType = "E";
        this.warningMsg = fileExtns + " file type is not allowed, please choose allowed file type.";
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: this.warningMsg,
            type: warningMsgType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: warningMsgType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }
    }
  }

  showDocumentsSearchGrid: boolean;
  searchByDocumentId: any = null;
  searchByDocumetnName: any = null;
  searchByDocumentType: any = [];
  documentTypeValue: any;
  searchDmsDocumentsVwDetails: any;
  getDmsDocumentsVwDetailsTableData: any = [];
  searchDocumentChildCheckBoxs = false;
  selectedIssuanceAddType: any;
  IsApplicableAdditionalDetail = false;
  IsApplicableRevApp = false;

  changeRevApp(val: any) {
    this.documentDataForDocBulkUpload.IsApplicableRevApp = val;
    this.documentDataForDocBulkUpload.docsList = this.resultList;
  }

  searchDocumentFunction() {
    this.searchDocumentChildCheckBoxs = false;
    this.showDocumentsSearchGrid = false;
    this.searchByDocumentId = null;
    this.searchByDocumetnName = null;
    this.searchByDocumentType = [];
    this.popupDataTitle.title = "Search Document";
    this.visibleSearchDocumentPopup = this.dialog.open(this.searchDocument, this.searchDocumentConfig);
  }

  selectDiffFolderFunc() {
    this.isShowAddPanel = false;
    this.isAddDocForDocType = true;
  }

  documentName: any;
  documentType: any;
  belongsToUser: any;
  description: any;
  crFeild: any;
  versionCss: any;
  documentNoCss: any;
  documentNameRequiredMsg: any;
  documentTypeRequiredMsg: any;
  belongsToUserRequiredMsg: any;
  descriptionRequiredMsg: any;
  crFieldRequiredMsg: any;
  versionCssReqdMsg: any;
  documentNoCssReqdMsg: any;
  revisionhistory: any;
  revisiondescriptionRequiredMsg: any;
  fieldDocumentValidation() {
    this.documentName = document.getElementById('documentName') as HTMLInputElement;
    this.documentType = document.getElementById('documentType') as HTMLInputElement;
    this.belongsToUser = document.getElementById('documentName') as HTMLInputElement;
    this.description = document.getElementById('description') as HTMLInputElement;
    this.crFeild = document.getElementById('cr') as HTMLInputElement;
    this.revisionhistory = document.getElementById('revisionHistory') as HTMLInputElement;

    this.documentNameRequiredMsg = document.getElementById('documentName-required-msg') as HTMLInputElement;
    this.documentTypeRequiredMsg = document.getElementById('documentType-required-msg') as HTMLInputElement;
    this.belongsToUserRequiredMsg = document.getElementById('belongsToUser-required-msg') as HTMLInputElement;
    this.revisiondescriptionRequiredMsg = document.getElementById('revisionHistory-required-msg') as HTMLInputElement;
    this.descriptionRequiredMsg = document.getElementById('description-required-msg') as HTMLInputElement;
    this.crFieldRequiredMsg = document.getElementById('cr-required-msg') as HTMLInputElement;

    if (this.documentDataForDocBulkUpload.documentDescription) {
      this.description.style.border = 'none';
      this.descriptionRequiredMsg.style.display = 'none';
    } else {
      this.description.style.border = '1px solid red';
      this.descriptionRequiredMsg.style.display = 'block';
    }

    if (this.documentDataForDocBulkUpload.revisionHistory) {
      this.revisionhistory.style.border = 'none';
      this.revisiondescriptionRequiredMsg.style.display = 'none';
    } else {
      this.revisionhistory.style.border = '1px solid red';
      this.revisiondescriptionRequiredMsg.style.display = 'block';
    }

    if (this.selectedDocumentTypeForDoc) {
      this.documentType.style.border = 'none';
      this.documentTypeRequiredMsg.style.display = 'none';
    } else {
      this.documentType.style.border = '1px solid red';
      this.documentTypeRequiredMsg.style.display = 'block';
    }

    if (this.isCrFeildIsMandatory) {
      if (this.documentDataForDocBulkUpload.crNo == null) {
        this.crFeild.style.border = '1px solid red';
        this.crFieldRequiredMsg.style.display = 'block';
      } else {
        this.crFeild.style.border = 'none';
        this.crFieldRequiredMsg.style.display = 'none';
      }
    }

    if (this.isVersionManuallyForDocType) {
      this.versionCss = document.getElementById('versionForDocType') as HTMLInputElement;
      this.versionCssReqdMsg = document.getElementById('versionForDocType-required-msg') as HTMLInputElement;
      if (this.documentDataForDocBulkUpload.version == null || this.documentDataForDocBulkUpload.version == "") {
        this.versionCss.style.border = '1px solid red';
        this.versionCssReqdMsg.style.display = 'block';
      } else {
        this.versionCss.style.border = 'none';
        this.versionCssReqdMsg.style.display = 'none';
      }
    }
  }

  config: EditorConfig = {
    placeholder: '',
    buttons: ST_BUTTONS,
  };

  resultList: any = [];
  isMandatoryField = false;
  onclickedSaveButton = false;
  selectedDocId: any = null;
  addDocForBulkUploadFunc() {
    if (this.filesListToUpload.length == 0) {
      alert("Please upload documents!");
    } else {
      this.isProcessing = true;
      const isDescriptionInvalid = !this.documentDataForDocBulkUpload['documentDescription'] ||
        String(this.documentDataForDocBulkUpload['documentDescription']).trim() === "";

      const isRevisionInvalid = !this.documentDataForDocBulkUpload.revisionHistory ||
        String(this.documentDataForDocBulkUpload.revisionHistory).trim() === "";

      const isVersionInvalid = this.isVersionManuallyForDocType &&
        (!this.documentDataForDocBulkUpload.version || String(this.documentDataForDocBulkUpload.version).trim() === "");

      if (!this.selectedDocumentTypeForDoc ||
        isDescriptionInvalid ||
        isRevisionInvalid ||
        (this.isCrFeildIsMandatory && this.documentDataForDocBulkUpload.crNo == null) ||
        isVersionInvalid
      ) {
        this.fieldDocumentValidation();
        this.isProcessing = false;
      } else {
        let data: any = [];

        this.documentDataForDocBulkUpload.documentTypeCode = this.selectedDocumentTypeForDoc;
        this.documentDataForDocBulkUpload.isBlinded = this.documentDataForDocType.isBlinded1 ? "Y" : "N";
        this.documentDataForDocBulkUpload.folderId = this.selectedFolderId;
        this.documentDataForDocBulkUpload.docOrPlaceholder = 'DOCUMENT';
        for (const file of this.filesListToUpload ?? []) {
          data.push({
            ...this.documentDataForDocBulkUpload,
            documentExtn: file.extension,
            documentName: file.originalFileName,
            uploadFolderPath: `${file.uploadPath}/${file.fileName}.${file.extension}`
          });
        }
        this.isProcessing = true;
        this.appService.createBulkDmsDocument(data).subscribe({
          next: (Response: any) => {
            this.savedFlexiDocIds = [];
            this.resultList = [];
            this.isProcessing = false;
            if (Response.resultType != undefined && Response.resultType == "E") {
              this.resultList.push(Response);
            } else {
              this.resultList = Response;
              this.message.docsList = this.resultList;
              this.selectedDocId = this.resultList[0].documentId;
              this.valueChange.emit(true);
              if (this.selectedDocId) {
                this.getDocumentRelatedDetails(this.selectedDocId, true);
              } else {
                this.documentDataForDocBulkUpload = {};
              }

            }

            this.visibleDisplayResultPopup = this.dialog.open(this.resultDisplayPopup, this.displayResultPopupConfig);
          }, error: (error) => {

            this.isProcessing = false;
            throw error;
          }
        });
      }

    }
  }

  addDocumentFunction() {
    if (this.selectedFolderForCreateDoc.documentId != undefined || this.selectedFolderForCreateDoc.documentId != null) {
      this.documentDataForDocBulkUpload.associatedDocumentId = this.selectedFolderForCreateDoc.documentId;
      this.documentDataForDocBulkUpload.associatedDocumentName = this.selectedFolderForCreateDoc.documentName;
      this.documentDataForDocBulkUpload.associatedFolderPath = this.selectedFolderForCreateDoc.folderPath;
      if (this.isShowExpDate && this.followSameExpDate) {
        if (this.selectedFolderForCreateDoc.expirationDate != null) {
          this.documentDataForDocBulkUpload.expirationDate = new Date(this.selectedFolderForCreateDoc.expirationDate);
        }
      }

      this.documentDataForDocBulkUpload.associatedStatus = this.selectedFolderForCreateDoc.status;
      this.visibleSearchDocumentPopup.close();
    } else {
      alert("Please select document!")
    }
    this.visibleSearchDocumentPopup.close();
  }


  cancelBulkUploadFunc() {
    this.valueChange.emit(true);
  }

  cancelConfirmationFunction() {
    this.visibleDisplayResultPopup.close();
  }

  cancelSearchDocumentFunction() {
    this.visibleSearchDocumentPopup.close();
  }

  isShowCheckBox = false;
  getDocumentRelatedDetails(selctedDocId: any, showCheckbox: any) {
    if (selctedDocId == this.resultList[0].documentId) {
      this.isShowCheckBox = true;
      this.message.isShowApplicableForAllCheckBox = true;
    } else {
      this.isShowCheckBox = false;
      this.message.isShowApplicableForAllCheckBox = false;
    }

    this.selectedDocId = selctedDocId;
    if (selctedDocId) {
      this.documentDataForDocBulkUpload = {};
      this.isProcessing = true;
      this.appService.getDocumentByDocIdFirstTime(this.selectedDocId)
        .subscribe((data: any) => {
          this.documentDataForDocBulkUpload = data[0];
          // Re-evaluate Document Configuration dynamically
          const selectedDocType = this.dropDownFordocumentTypeList?.find(
            (doc: any) => doc.documentTypeCode === this.documentDataForDocBulkUpload.documentTypeCode
          );

          if (selectedDocType) {
            this.documentTypeData = selectedDocType;
            this.isShowAssociatedDocumentField = (selectedDocType.isAssociatedDocumentType === "Y");
            this.isShowUserBelongsToField = (selectedDocType.belongsToIndividual === "Y");
            this.isShowIsBlindedFlag = (selectedDocType.isBlindable === "Y");
            this.isShowExpDate = (selectedDocType.isExpiryApplicable === "Y");
            this.followSameExpDate = (selectedDocType.associatedDocToFollowSameExpiry === "Y");

            if (selectedDocType.crProcess === "Mandatory" || selectedDocType.crProcess === "Non Mandatory") {
              this.isShowCrFields = true;
              this.isCrFeildIsMandatory = (selectedDocType.crProcess === "Mandatory");
            } else {
              this.isShowCrFields = false;
              this.isCrFeildIsMandatory = false;
            }
          }

          let btnObj = {

            documentId: this.documentDataForDocBulkUpload['documentId'],
            version: this.documentDataForDocBulkUpload['version'],
            folderId: this.selectedFolderId,
            status: this.documentDataForDocBulkUpload['status'],
            pageName: 'DOCUMENT'
          };

          this.appService.getDocumentButtonLabels(btnObj).subscribe((btnData: any) => {
            this.stageName = btnData.stageName;
            this.actionStatusOptions = btnData.actionStatusOptions;
            this.instructions = btnData.instructions;
            this.buttonLabels = [];
            if (btnData.buttonLabels != null) {
              let allButtons = btnData.buttonLabels.split(",");
              this.buttonLabels = allButtons.filter((lbl: string) => lbl === 'CheckIn' || lbl === 'Publish');
            }
          });

          if (this.documentDataForDocBulkUpload.effectiveDate != null) {
            this.documentDataForDocBulkUpload.effectiveDate = new Date(this.documentDataForDocBulkUpload.effectiveDate);
          }
          if (this.documentDataForDocBulkUpload.expirationDate != null) {
            this.documentDataForDocBulkUpload.expirationDate = new Date(this.documentDataForDocBulkUpload.expirationDate);
          }

          this.documentDataForDocBulkUpload['module'] = "DOCS";
          this.documentDataForDocBulkUpload['saveButtonForDocument'] = true;
          this.isProcessing = false;

          if (this.flexiFieldsList?.length > 0) {
            this.isShowFlexifieldBlock = true;
          }

          if (this.documentDataForDocBulkUpload['documentId'] != null) {
            this.appService.getFlexifieldDataWithDocIdAndVersion(

              this.documentDataForDocBulkUpload['documentId'],
              this.documentDataForDocBulkUpload['version']
            ).subscribe((flexiData: any) => {
              if (flexiData.length > 0) {
                this.flexifieldObj = flexiData[0];

                // Track ID securely
                if (!this.savedFlexiDocIds.includes(this.documentDataForDocBulkUpload['documentId'])) {
                  this.savedFlexiDocIds.push(this.documentDataForDocBulkUpload['documentId']);
                }

                for (const field of this.flexiFieldsList ?? []) {
                  if (field.mappingColumn != null) {
                    const finalVariable = this.makeVariable(field);
                    const rowData = flexiData?.[0];
                    const rawValue = rowData?.[finalVariable];

                    if (rawValue) {
                      field.recordId = rowData.recordId;

                      if (field.fieldDatatype === "Date" || field.fieldDatatype === "Datetime") {
                        field.fieldDefaultValue = rawValue ? new Date(rawValue) : null;
                      } else if (field.fieldDatatype === "Number") {
                        field.fieldDefaultValue = String(rawValue);
                      } else {
                        field.fieldDefaultValue = rawValue;
                      }

                      if (field.fieldType === "Multiselect Drop Down") {
                        field.selectedFlexifieldValue = rawValue === '' ? [] : String(rawValue).split(',');
                      }

                      if (field.fieldType === "Vertical Checkbox Button" || field.fieldType === "Horizontal Checkbox Button") {
                        if (field.fieldDefaultValue != null) {
                          const isNumeric = field.fieldDatatype === "Number" && !Number.isNaN(Number(field.fieldDefaultValue));
                          if (isNumeric) {
                            field.checkedCheckBoxValue = [field.fieldDefaultValue];
                          } else {
                            field.checkedCheckBoxValue = String(field.fieldDefaultValue).split(",");
                          }
                        }
                      }
                    } else {
                      field.fieldDefaultValue = field.originalDefaultValue || null;
                      if (field.fieldType === 'Multiselect Drop Down') {
                        field.selectedFlexifieldValue = field.fieldDefaultValue ? String(field.fieldDefaultValue).split(',') : [];
                      } else if (field.fieldType === 'Vertical Checkbox Button' || field.fieldType === 'Horizontal Checkbox Button') {
                        field.checkedCheckBoxValue = field.fieldDefaultValue ? String(field.fieldDefaultValue).split(',') : [];
                      }
                    }
                  }
                }
              } else {
                this.flexifieldObj = {};
                this.flexifieldObj.recordId = null;

                // =======================================================
                // BUG FIX: DELETED THE AGGRESSIVE `.splice()` HERE!
                // The frontend now securely trusts your session saves.
                // =======================================================

                for (const field of this.flexiFieldsList ?? []) {
                  if (field.mappingColumn) {
                    this.makeVariable(field);

                    field.fieldDefaultValue = field.originalDefaultValue || null;
                    if (field.fieldType === 'Multiselect Drop Down') {
                      field.selectedFlexifieldValue = field.fieldDefaultValue ? String(field.fieldDefaultValue).split(',') : [];
                    } else if (field.fieldType === 'Vertical Checkbox Button' || field.fieldType === 'Horizontal Checkbox Button') {
                      field.checkedCheckBoxValue = field.fieldDefaultValue ? String(field.fieldDefaultValue).split(',') : [];
                    }
                  }
                }
              }
            });
          }

          this.appService.getTaskStages(
            this.documentDataForDocBulkUpload['documentId'],
            this.documentDataForDocBulkUpload['version']
          ).subscribe((taskData: any) => {
            this.taskStagesList = taskData;
            this.isProcessing = false;
          });
        });
    } else {
      this.documentDataForDocBulkUpload = {};
      this.taskStagesList = [];
      this.isShowFlexifieldBlock = false;
    }
  }
  toggleSelectAllFlexifield(event: any, flexifield: any) {
    if (event.checked) {
      flexifield.selectedFlexifieldValue = flexifield.dropdowns.map((item: any) => item.valueExp);
    } else {
      flexifield.selectedFlexifieldValue = [];
    }
  }

  saveFlexifieldData(): void {
    this.flexifieldValidation(); // Highlight UI errors first

    if (!this.validateFlexiFields()) {
      this.warningMsg = "Please enter all mandatory Additional Details before saving.";
      this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
      return;
    }

    this.isMandatoryField = false;
    this.onclickedSaveButton = true;
    this.isProcessing = true;


    let pendingRequests = 0;
    let hasError = false;

    // Track when all requests finish
    const onComplete = (success: boolean) => {
      if (!success) hasError = true;
      pendingRequests--;
      if (pendingRequests === 0) {
        this.isProcessing = false;
        if (hasError) {
          this.showSnackBar("Some additional details failed to save.", "E");
        } else {
          this.showSnackBar("Additional details saved successfully.", "S");
        }
      }
    };

    if (this.IsApplicableAdditionalDetail) {
      const docsToSave = this.resultList?.filter((r: any) => r.documentId != null) || [];
      pendingRequests = docsToSave.length;

      if (pendingRequests === 0) {
        this.isProcessing = false;
        return;
      }

      for (const result of docsToSave) {
        const obj: any = { refId: result.documentId, version: result.version };
        this.callFlexifieldSave(obj, onComplete);
      }
    } else {
      const bulkData = this.documentDataForDocBulkUpload;
      if (!bulkData?.documentId) {
        this.isProcessing = false;
        return;
      }
      pendingRequests = 1;
      const obj: any = { refId: bulkData.documentId, version: bulkData.version };
      this.callFlexifieldSave(obj, onComplete);
    }
  }


  callFlexifieldSave(obj: any, onComplete: (success: boolean) => void) {
    for (const field of this.flexiFieldsList ?? []) {
      if (field.mappingColumn != null) {
        const finalVariable: string = this.makeVariable(field);
        const isCheckbox: boolean = field.fieldType === "Horizontal Checkbox Button" || field.fieldType === "Vertical Checkbox Button";
        const isMultiselect: boolean = field.fieldType === "Multiselect Drop Down";

        if (isCheckbox) {
          field.fieldDefaultValue = field.checkedCheckBoxValue?.length > 0
            ? field.checkedCheckBoxValue.join(',')
            : null;
        } else if (isMultiselect) {
          field.fieldDefaultValue = field.selectedFlexifieldValue?.length > 0
            ? field.selectedFlexifieldValue.join(',')
            : null;
        }

        obj[finalVariable] = field.fieldDefaultValue;
      }
    }

    const currentDocIdStr = String(this.documentDataForDocBulkUpload?.documentId).trim();
    const objRefIdStr = String(obj.refId).trim();
    const isCurrentDoc = objRefIdStr === currentDocIdStr;

    // Helper function to safely add to tracker
    const trackSuccess = () => {
      if (!this.savedFlexiDocIds.includes(objRefIdStr)) {
        this.savedFlexiDocIds.push(objRefIdStr);
      }
    };

    if (this.flexifieldObj['recordId'] && isCurrentDoc) {
      obj.recordId = this.flexifieldObj['recordId'];
      this.appService.updateFlexifieldData(obj).subscribe({
        next: (data: any) => {
          // Forcefully track success if no HTTP error occurs
          trackSuccess();
          onComplete(true);
        },
        error: () => onComplete(false)
      });
    } else {
      this.appService.addFlexifieldData(obj).subscribe({
        next: (data: any) => {
          // Forcefully track success if no HTTP error occurs
          trackSuccess();
          onComplete(true);
        },
        error: () => onComplete(false)
      });
    }
  }

  validateBulkFlexiFields(): boolean {
    let hasMandatory = this.flexiFieldsList?.some((f: any) => f.isMandatory === 'Y');
    if (!hasMandatory) return true;

    for (let doc of this.resultList) {
      if (doc.documentId) {
        // Enforce strict string checking
        const docIdStr = String(doc.documentId).trim();
        if (!this.savedFlexiDocIds.includes(docIdStr)) {
          return false;
        }
      }
    }
    return true;
  }
  updateDocumentDetails() {
    if (this.documentDataForDocBulkUpload.documentId == undefined || this.documentDataForDocBulkUpload.documentId == null) {

      this.documentDataForDocBulkUpload.documentTypeCode = this.selectedDocumentTypeValue;
      this.documentDataForDocBulkUpload.isBlinded = this.documentDataForDocBulkUpload.isBlinded1 ? "Y" : "N";
      this.documentDataForDocBulkUpload.folderId = this.selectedFolderId;
      this.documentDataForDocBulkUpload.documentExtn = null;

      const formData = new FormData();
      formData.append('file', this.document ?? '');
      const json = JSON.stringify(this.documentDataForDocBulkUpload);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      formData.append('dmsDocumentDto', blob);
      this.isProcessing = true;
      this.appService.createDmsDocument(formData).subscribe({
        next: (Response: any) => {
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;


        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {

      this.documentDataForDocBulkUpload.documentTypeCode = this.selectedDocumentTypeValue;
      this.documentDataForDocBulkUpload.isBlinded = this.documentDataForDocBulkUpload.isBlinded1 ? "Y" : "N";
      this.documentDataForDocBulkUpload.documentExtn = null;

      const formData = new FormData();
      formData.append('file', this.document ?? '');
      const json = JSON.stringify(this.documentDataForDocBulkUpload);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      formData.append('dmsDocumentDto', blob);
      this.isProcessing = true;
      this.appService.updateDmsDocument(formData).subscribe({
        next: (Response: any) => {
          this.isProcessing = false;

          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;


        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }

  }

  removeFile(file: any, i: any) {
    this.filesListToUpload.splice(i, 1);
    this.uploadedFiles.splice(i, 1);

  }

  dynamicButtonClick(button: string) {
    if (this.isShowFlexifieldBlock) {
      if (!this.validateFlexiFields()) {
        this.warningMsg = "Please fill all mandatory Additional Details before proceeding.";
        this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
        return;
      }

      // Strict tracking validation
      let hasMandatory = this.flexiFieldsList?.some((f: any) => f.isMandatory === 'Y');
      const currentDocIdStr = String(this.documentDataForDocBulkUpload?.documentId).trim();

      if (hasMandatory && !this.savedFlexiDocIds.includes(currentDocIdStr)) {
        this.warningMsg = "Please save your changes by clicking the 'Save Additional Details' button before proceeding.";
        this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
        return;
      }
    }

    this.buttonLabel = button;
    this.reason = "";
    this.isApplyToAllCheckIn = false;

    if (button === "CheckIn") {
      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    } else if (button === "Publish") {
      if (this.documentDataForDocBulkUpload.effectiveDate) {
        this.documentDataForDocBulkUpload.effectiveDate = new Date(this.documentDataForDocBulkUpload.effectiveDate);
      } else {
        this.documentDataForDocBulkUpload.effectiveDate = new Date();
      }

      if (this.documentDataForDocBulkUpload.expirationDate) {
        this.documentDataForDocBulkUpload.expirationDate = new Date(this.documentDataForDocBulkUpload.expirationDate);
      } else if (this.documentTypeData?.expiryInUnit) {
        this.selectExpValue(new Date(this.documentDataForDocBulkUpload.effectiveDate));
      }

      this.trainingList = [];
      this.selectedTrainingIds = [];
      this.selectedTrainingId = null;
      this.isProcessing = true;

      let obj = {
        documentId: this.documentDataForDocBulkUpload.documentId,
        documentVersion: this.documentDataForDocBulkUpload.version
      };

      this.appService.getContentsBasedOnDocId(obj).subscribe((data: any) => {
        this.isProcessing = false;
        for (let i = 0; i < data.length; i++) {
          let trObj = { "trainingId": data[i].trainingId, "version": data[i].version };
          if (this.trainingList.findIndex(t => t.trainingId === trObj.trainingId) === -1) {
            this.trainingList.push(trObj);
            this.selectedTrainingIds.push(trObj.trainingId);
          }
        }
        if (this.trainingList.length > 0) {
          this.selectedTrainingId = this.selectedTrainingIds.join(",");
          this.newRun("tr", this.selectedTrainingId);
        }
      });

      this.visiblPublishPopup = this.dialog.open(this.publishPopup, this.publishPopupConfig);
    }
  }
  newRun(type: any, val: any) {
    this.isProcessing = true;
    let attaptedVal = this.message.showRetakeAndMarkasCompleted ? "noNeedConsiderForReport" : "NeedConsiderForReport";

    this.appService.getOneQmsUserTrainingsRepVwMain(type, val, attaptedVal).subscribe((data: any) => {
      this.getOneQmsUsersTrainingsRepVwDetails = data;
      this.collectionSize = this.getOneQmsUsersTrainingsRepVwDetails.length;
      this.setPageMain(1, 0);
      this.isProcessing = false;
    });
  }

  setPageMain(page: number, targetpage: number) {
    if (page < 1 || (this.pager.totalPages && page > this.pager.totalPages)) return;
    if (Number.isNaN(page)) page = 1;

    this.pager = this.paginationService.getPager(this.getOneQmsUsersTrainingsRepVwDetails.length, page, this.perPage, targetpage);
    if (this.getOneQmsUsersTrainingsRepVwDetails.length > 0) {
      this.pagedItemsMain = this.getOneQmsUsersTrainingsRepVwDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCallMain(value: number) {
    this.perPage = value;
    this.setPageMain(this.pager.currentPage, 0);
  }

  cancelConfirmFunc() {
    this.visibleConfirmWithReason.close();
  }
  confirmWithReasonFunc() {
    if (this.buttonLabel === 'CheckIn') {
      const reasonEl = document.getElementById('reason') as HTMLInputElement;
      const reasonRequiredMsg = document.getElementById('reason-required-msg') as HTMLInputElement;

      // Validation
      if (!this.reason || this.reason.trim() === '') {
        if (reasonEl) reasonEl.style.border = '1px solid red';
        if (reasonRequiredMsg) reasonRequiredMsg.style.display = 'block';
        return;
      } else {
        if (reasonEl) reasonEl.style.border = 'none';
        if (reasonRequiredMsg) reasonRequiredMsg.style.display = 'none';
      }

      this.isProcessing = true;

      if (this.isApplyToAllCheckIn && this.isShowCheckBox) {
        if (!this.validateBulkFlexiFields()) {
          this.isProcessing = false;
          this.warningMsg = "Please fill and save Additional Details for all documents (or use 'Applicable To All Documents') before performing a bulk CheckIn.";
          this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
          return;
        }
        this.performBulkButtonOperation();
      } else {
        this.performCommonOperation(this.documentDataForDocBulkUpload, false);
      }
    }
  }

  executeAction() {
    this.isProcessing = true;
    if (this.isApplyToAll && this.isShowCheckBox) {
      if (!this.validateBulkFlexiFields()) {
        this.isProcessing = false;
        this.warningMsg = "Please fill and save Additional Details for all documents (or use 'Applicable To All Documents') before performing a bulk Publish.";
        if (this.visiblPublishPopup) this.visiblPublishPopup.close();
        if (this.visiblPublishConfirmPopup) this.visiblPublishConfirmPopup.close();

        this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
        return;
      }
      this.performBulkButtonOperation();
    } else {
      this.performCommonOperation(this.documentDataForDocBulkUpload, false);
    }
  }
  okPublishFunc() {
    const effectiveDateEl = document.getElementById('effectiveDate') as HTMLInputElement;
    const effectiveDateRequiredMsg = document.getElementById('effectiveDate-required-msg');

    let hasError = false;
    if (this.documentDataForDocBulkUpload.effectiveDate) {
      if (effectiveDateEl) effectiveDateEl.style.border = 'none';
      if (effectiveDateRequiredMsg) effectiveDateRequiredMsg.style.display = 'none';
    } else {
      if (effectiveDateEl) effectiveDateEl.style.border = '1px solid red';
      if (effectiveDateRequiredMsg) effectiveDateRequiredMsg.style.display = 'block';
      hasError = true;
    }

    if (hasError) return;

    if (this.getOneQmsUsersTrainingsRepVwDetails.length > 0) {
      this.visiblPublishConfirmPopup = this.dialog.open(this.publishConfirmPopup, this.publishConfirmPopupConfig);
    } else {
      this.executeAction();
    }
  }

  confirmPublishWarningFunc() {
    this.executeAction();
  }



  cancelPublishFunc() { this.visiblPublishPopup.close(); }
  cancelConfirmPublishFunc() { this.visiblPublishConfirmPopup.close(); }

  performBulkButtonOperation() {
    let completedCount = 0;
    let documentsToProcess = 0;
    this.bulkOperationResults = [];

    const commonEffectiveDate = this.documentDataForDocBulkUpload.effectiveDate;
    const commonExpirationDate = this.documentDataForDocBulkUpload.expirationDate;

    for (let i = 0; i < this.resultList.length; i++) {
      if (this.resultList[i].documentId) documentsToProcess++;
    }

    if (documentsToProcess === 0) {
      this.isProcessing = false;
      return;
    }

    for (let i = 0; i < this.resultList.length; i++) {
      let doc = this.resultList[i];
      if (doc.documentId) {
        if (this.buttonLabel === 'Publish') {
          doc.effectiveDate = commonEffectiveDate;
          doc.expirationDate = commonExpirationDate;
        }

        this.performCommonOperation(doc, true, () => {
          completedCount++;
          if (completedCount === documentsToProcess) {
            this.isProcessing = false;
            if (this.visibleConfirmWithReason) this.visibleConfirmWithReason.close();
            if (this.visiblPublishPopup) this.visiblPublishPopup.close();
            if (this.visiblPublishConfirmPopup) this.visiblPublishConfirmPopup.close();

            this.visibleBulkResultPopup = this.dialog.open(this.bulkResultPopup, this.displayResultPopupConfig);
            this.getDocumentRelatedDetails(this.selectedDocId, this.isShowCheckBox);
          }
        });
      }
    }
  }

  performCommonOperation(docData: any, isBulk: boolean, callback?: () => void) {
    let data = {

      documentId: docData.documentId,
      version: docData.version,
      currentStatus: docData.status || this.documentDataForDocBulkUpload.status,
      stageName: null,
      buttonValue: this.buttonLabel,
      actionStatus: null,
      crNo: null,
      comments: this.reason,
      rejectReason: null,
      reasonForSignature: null,
      fileExtn: null,
      effectiveDate: docData.effectiveDate,
      expirationDate: docData.expirationDate
    };

    const formData = new FormData();
    const emptyfile: File | null = null;
    if (emptyfile) {
      formData.append('file', emptyfile);
    }
    const json = JSON.stringify(data);
    formData.append('object', new Blob([json], { type: 'application/json' }));

    this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
      if (isBulk) {
        // Log result for the bulk popup
        this.bulkOperationResults.push({
          documentName: docData.documentName || `Document ${docData.documentId}`,
          status: Response.resultType === 'S' ? (this.buttonLabel === 'CheckIn' ? 'Checked In' : 'Published') : Response.result,
          isSuccess: Response.resultType === 'S'
        });
        if (callback) callback();
      } else {
        // Single document flow
        this.isProcessing = false;
        if (this.visibleConfirmWithReason) this.visibleConfirmWithReason.close();
        if (this.visiblPublishPopup) this.visiblPublishPopup.close();
        if (this.visiblPublishConfirmPopup) this.visiblPublishConfirmPopup.close();

        this.showSnackBar(Response.result, Response.resultType);

        if (Response.resultType === 'S') {
          this.getDocumentRelatedDetails(this.selectedDocId, this.isShowCheckBox);
        }
      }
    }, error => {
      if (isBulk) {
        this.bulkOperationResults.push({
          documentName: docData.documentName || `Document ${docData.documentId}`,
          status: "Error processing document",
          isSuccess: false
        });
        if (callback) callback();
      } else {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  validateFlexiFields(): boolean {
    let isValid = true;
    for (const field of this.flexiFieldsList ?? []) {
      if (field.isMandatory === 'Y') {
        const isCheckbox = field.fieldType === 'Horizontal Checkbox Button' || field.fieldType === 'Vertical Checkbox Button';
        const isMultiselect = field.fieldType === 'Multiselect Drop Down';

        if (isCheckbox) {
          if ((field.checkedCheckBoxValue?.length ?? 0) === 0) isValid = false;
        } else if (isMultiselect) {
          if (!field.selectedFlexifieldValue || field.selectedFlexifieldValue.length === 0) isValid = false;
        } else {
          if (field.fieldDefaultValue == null || String(field.fieldDefaultValue).trim() === '') {
            isValid = false;
          }
        }

        if (!isValid) break;
      }
    }
    return isValid;
  }

  closeBulkResultPopup() {
    if (this.visibleBulkResultPopup) {
      this.visibleBulkResultPopup.close();
    }
  }

  canShowSaveButtons(): boolean {
    const flag = this.documentDataForDocBulkUpload?.checkoutFlag;
    if (!flag) {
      return true;
    }

    const cleanFlag = String(flag).trim().toUpperCase();
    return cleanFlag !== 'Y';
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.uploadedFiles, event.previousIndex, event.currentIndex);
    if (this.filesListToUpload.length === this.uploadedFiles.length) {
      moveItemInArray(this.filesListToUpload, event.previousIndex, event.currentIndex);
    }
  }
}
